export const ExtraDocExportConfigTableData = (feature: boolean) => {
    return [{ 
        headerClassName: 'data-table header',
        show: feature,
        accessor: 'productType',
        id: 'productType-col',
        fieldHeader: 'Product Type',
        sortable: true
    },
    {
        fieldHeader: 'Shipper',
        accessor: 'shipper',
        className: 'shipper',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Consignee',
        accessor: 'consignee',
        className: 'consignee',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Port of Load',
        accessor: 'portOfLoad',
        className: 'portOfLoad',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Place of Receipt',
        accessor: 'placeOfReceipt',
        className: 'placeOfReceipt',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Origin Service',
        accessor: 'originService',
        className: 'originService',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Destination Service',
        accessor: 'destinationService',
        className: 'destinationService',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Transportation Mode',
        accessor: 'transportationMode',
        className: 'transportationMode',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'IncoTerm',
        accessor: 'incoTerm',
        className: 'incoTerm',
        show: false,
        editable: false,
        sortable: false,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'PREFIX',
        accessor: 'prefix',
        className: 'prefix',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Company Code',
        accessor: 'companyCode',
        className: 'companyCode',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Sales Org',
        accessor: 'salesOrganization',
        className: 'salesOrganization',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Division',
        accessor: 'division',
        className: 'division',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Document Issuer',
        accessor: 'documentIssuer',
        className: 'documentIssuer',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Sales Office',
        accessor: 'salesOffice',
        className: 'salesOffice',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Plant',
        accessor: 'plant',
        className: 'plant',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Created By',
        accessor: 'createdBy',
        className: 'createdBy',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Created On',
        accessor: 'createdOn',
        className: 'createdOn',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Updated By',
        accessor: 'updatedBy',
        className: 'updatedBy',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Updated On',
        accessor: 'updatedOn',
        className: 'updatedOn',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Status',
        accessor: 'isDeleted',
        className: 'isDeleted',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'ID',
        accessor: 'id',
        className: 'id',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }
]};

export const ExtraDocImportConfigTableData = (feature: boolean) => {
    return [{ 
        headerClassName: 'data-table header',
        show: feature,
        accessor: 'productType',
        id: 'productType-col',
        fieldHeader: 'Product Type',
        sortable: true
    },
    {
        fieldHeader: 'Consignee',
        accessor: 'consignee',
        className: 'consignee',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Port of Load',
        accessor: 'portOfLoad',
        className: 'portOfLoad',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Client Place of Delivery',
        accessor: 'clientPlaceOfDelivery',
        className: 'clientPlaceOfDelivery',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Place of Receipt',
        accessor: 'placeOfReceipt',
        className: 'placeOfReceipt',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Carrier Place of Delivery',
        accessor: 'carrierPlaceOfDelivery',
        className: 'carrierPlaceOfDelivery',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Port of Discharge',
        accessor: 'portOfDischarge',
        className: 'portOfDischarge',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Origin Service',
        accessor: 'originService',
        className: 'originService',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Destination Service',
        accessor: 'destinationService',
        className: 'destinationService',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Transportation Mode',
        accessor: 'transportationMode',
        className: 'transportationMode',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'IncoTerm',
        accessor: 'incoTerm',
        className: 'incoTerm',
        show: false,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Company Code',
        accessor: 'companyCode',
        className: 'companyCode',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Sales Org',
        accessor: 'salesOrganization',
        className: 'salesOrganization',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Division',
        accessor: 'division',
        className: 'division',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Sales Office',
        accessor: 'salesOffice',
        className: 'salesOffice',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    },  {
        fieldHeader: 'Plant',
        accessor: 'plant',
        className: 'plant',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Created By',
        accessor: 'createdBy',
        className: 'createdBy',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Created On',
        accessor: 'createdOn',
        className: 'createdOn',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Updated By',
        accessor: 'updatedBy',
        className: 'updatedBy',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Updated On',
        accessor: 'updatedOn',
        className: 'updatedOn',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'Status',
        accessor: 'isDeleted',
        className: 'isDeleted',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }, {
        fieldHeader: 'ID',
        accessor: 'id',
        className: 'id',
        show: true,
        editable: false,
        sortable: true,
        headerClassName: 'data-table header'
    }
]};